import { defineStore } from 'pinia';

export const useActivityStore = defineStore('activityStore', {
  state: () => ({
    pages: {} as Record<string, { visitCount: number; totalTime: number; lastEntryTime: number | null }>,
    featureClicks: {} as Record<string, number>,
    timeOfDayActivity: [] as { timestamp: number; period: string }[],
  }),
  actions: {
    // Log when a page is visited
    logPageVisit(pageName: string) {
      if (!this.pages[pageName]) {
        this.pages[pageName] = { visitCount: 0, totalTime: 0, lastEntryTime: null };
      }

      this.pages[pageName].visitCount += 1; // Increment visit count
      this.pages[pageName].lastEntryTime = Date.now(); // Record entry time
    },

    // Log when a page is exited
    logPageExit(pageName: string) {
      const page = this.pages[pageName];
      if (page && page.lastEntryTime) {
        const timeSpent = Date.now() - page.lastEntryTime; // Calculate time spent
        page.totalTime += timeSpent;
        page.lastEntryTime = null; // Reset last entry time
      }
    },

    // Log feature button clicks
    logFeatureClick(featureName: string) {
      if (!this.featureClicks[featureName]) {
        this.featureClicks[featureName] = 0; // Initialize if not already tracked
      }

      this.featureClicks[featureName] += 1; // Increment click count
    },

    // Log time-of-day activity
    logTimeOfDayActivity() {
      const now = new Date();
      const hour = now.getHours();
      let period = '';

      if (hour >= 5 && hour < 12) {
        period = 'Morning';
      } else if (hour >= 12 && hour < 17) {
        period = 'Afternoon';
      } else if (hour >= 17 && hour < 21) {
        period = 'Evening';
      } else {
        period = 'Night';
      }

      this.timeOfDayActivity.push({ timestamp: now.getTime(), period });
    },

    // Retrieve analytics data
    getPageAnalytics() {
      return this.pages;
    },
    getFeatureAnalytics() {
      return this.featureClicks;
    },
    getTimeOfDayAnalytics() {
      return this.timeOfDayActivity;
    },
  },
});
